module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAAAAXNSR0IArs4c6QAAADdJREFUKBVjDHvM/Z+BRMBEonqwchaYplWyXxlhbFw0zFVk2TSqCRqs9AsIRliE4YpQbOJkOQ8AxOYIobik/7kAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/chart5-icon/New Patch .png
// module id = 311
// module chunks = 7